<template>
  <section class="panel" :class="{ flush }">
    <header v-if="title || $slots.actions || $slots.title" class="panel-head">
      <div class="panel-titles">
        <h3 v-if="title || $slots.title"><slot name="title">{{ title }}</slot></h3>
        <p v-if="subtitle" class="panel-sub">{{ subtitle }}</p>
      </div>
      <div v-if="$slots.actions" class="panel-actions"><slot name="actions" /></div>
    </header>
    <div class="panel-body"><slot /></div>
  </section>
</template>

<script>
export default {
  name: 'DataPanel',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    // flush = no body padding (for tables that manage their own spacing)
    flush: { type: Boolean, default: false }
  }
}
</script>

<style scoped>
.panel {
  background: var(--panel-bg);
  border: 1px solid var(--panel-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-soft);
}
.panel-titles { min-width: 0; }
.panel-head h3 { margin: 0; font-size: 14px; font-weight: 600; color: var(--text-primary); }
.panel-sub { margin: 3px 0 0; font-size: 12px; color: var(--text-secondary); }
.panel-actions { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.panel-body { padding: 14px 16px; }
.panel.flush .panel-body { padding: 0; }
</style>
